// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Dd6Y","delete":"styles_delete__aiFGK","update":"styles_update__1JfF1","add":"styles_add__2V_T2"};